module.exports = __webpack_public_path__ + "img/badge-list-thumb-105.a5c83edd.png";